import * as React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import chairman from '../../assets/images/HomeDesk/chairman.png';
// import director from '../../assets/images/HomeDesk/Directors_desk.jpg'
import newDirector from "../../assets/images/HomeDesk/newDirectorT.jpg"
import coordinator from '../../assets/images/HomeDesk/Prof.Dr.NiveditaEkboteCo-ordinator.jpg';
import { Typography } from '@mui/material';


//old - 10-07-2025
// export default function MediaControlCard() {
//   const theme = useTheme();
//   return (
//     <>
//       <Card  sx={{ display: 'flex', marginBottom: 2 }} elevation={3} className='cardMobileView box'>
//         <Box sx={{ display: 'flex', flexDirection: 'column', maxHeight: 146, lineHeight: 1.3}}>
//           <CardContent sx={{ flex: '1 0 auto', padding: 1 }} className='textMobileView'>
//             <h6 className='decorated mb-1' >CHAIRMAN'S MESSAGE</h6>
//             <div className='P-tag text-justify mt-0 vertical-texts'>
//               It is our Commitment to The Students and Parents that Modern Institute of Business Management will definitely Honor two Words Which are Important...
//               <Link to={'/aboutUs/ChairmansDesk'} style={{ color: 'steelblue', fontSize: 13 }}> Read More...</Link>
//             </div>
//           </CardContent>
//         </Box>
//         <CardMedia
//           component="img"
//           sx={{ width: 130, padding: 1 }}
//           image={chairman}
//           alt="chairman"
//         />
//       </Card>
//       <Card sx={{ display: 'flex', marginBottom: 2 }} elevation={3}  className='cardMobileView box'>
//         <CardMedia
//           component="img"
//           sx={{ width: 130, padding: 1 }}
//           image={director}
//           alt="director"
//         />
//         <Box sx={{ display: 'flex', flexDirection: 'column', height: 145, lineHeight: 1.3}}>
//           <CardContent sx={{ flex: '1 0 auto', padding: 1 }}  className='textMobileView'>
//             <h6  className='decorated mb-1'>DIRECTOR'S DESK</h6>
//             <div className='P-tag text-justify mt-0 vertical-texts'>MIBM nurtures its Students to develop a Holistic approach, a curious mindset and the ability to think differently and innovatively to harness...
//               <Link to={'/aboutUs/DirectorsDesk'} style={{ color: 'steelblue', fontSize: 13 }}> Read More... </Link>
//             </div>
//           </CardContent>
//         </Box>

//       </Card>
//       <Card sx={{ display: 'flex', marginBottom: 2 }} elevation={3}  className='cardMobileView box'>
//         <Box sx={{ display: 'flex', flexDirection: 'column', maxHeight: 140, lineHeight: 1.3}} sm={{maxHeight:150}}>
//           <CardContent sx={{ flex: '1 0 auto', padding: 1 }}  className='textMobileView'>
//             <h6 className='decorated mb-1'>COORDINATOR'S DESK</h6>
//             <div className='P-tag text-justify mt-0 vertical-texts'> 
//                          The foundation of MIBM is its highly qualified and motivated faculties with their expertise in various areas like Economics, Finance...
//               <Link to={'/aboutUs/CoordinatorsDesk'} style={{ color: 'steelblue', fontSize: 13 }}> Read More... </Link>
//             </div>
//           </CardContent>
//         </Box>
//         <CardMedia
//           component="img"
//           sx={{ width: 130, padding: 1 }}
//           image={coordinator}
//           alt="coordinator"
//         />
//       </Card>
      
//     </>
//   );
// }


//new

export default function MediaControlCard() {
  return (
    <Box display="flex" justifyContent="center" gap={6} flexWrap="wrap" mb={6} px={2}>
      {/* Chairman Card */}
      <Card
        sx={{
          height: 450,
          width: 300,
          textAlign: "center",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          borderRadius:2,
          backgroundColor: '#e9ecf2',
          "&:hover": {
            transform: "scale(1.01)",
            boxShadow: "0px 12px 30px rgba(0, 0, 0, 0.4)",
            border: '1.3px solid #A70606'
          },
        }}
        elevation={3}
      >
        <CardMedia
          component="img"
          height="280"
          image={chairman}
          alt="Chairman"
        />
        <CardContent>
          <Typography variant="h6" style={{fontSize:'15px', color: '#A70606'}} gutterBottom >
            CHAIRMAN'S MESSAGE
          </Typography>
          <h5 style={{marginBottom:'9px', fontSize:'21px', fontWeight:'500'}}>Prof. Dr. Gajanan R. Ekbote</h5>
          <Typography
            variant="body2"
            className="P-tag text-justify vertical-texts"
          >
            It is our Commitment to The Students and Parents that Modern
            Institute of Business Management will definitely Honor two Words
            Which are Important...
            <Link
              to={"/aboutUs/ChairmansDesk"}
              style={{ color: "steelblue", fontSize: 13 }}
            >
              {" "}
              Read More...
            </Link>
          </Typography>
        </CardContent>
      </Card>

      {/* Director Card */}
      <Card
       sx={{
          height: 450,
          width: 300,
          textAlign: "center",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          borderRadius:2,
          backgroundColor: '#e9ecf2',
          "&:hover": {
            transform: "scale(1.01)",
            boxShadow: "0px 12px 30px rgba(0, 0, 0, 0.4)",
            border: '1.3px solid #A70606'
          },
        }}
        elevation={3}
      >
        <CardMedia
          component="img"
          height="280"
          image={newDirector}
          alt="Director"
        />
        <CardContent>
          <Typography variant="h6" style={{fontSize:'15px', color: '#A70606'}} gutterBottom>
            DIRECTOR'S DESK
          </Typography>
          <h5 style={{marginBottom:'9px', fontSize:'21px', fontWeight:'500'}}>Dr. Anamika Singh</h5>
          <Typography
            variant="body2"
            className="P-tag text-justify vertical-texts"
          >
            MIBM nurtures its Students to develop a Holistic approach, a curious
            mindset and the ability to think differently and innovatively to
            harness...
            <Link
              to={"/aboutUs/DirectorsDesk"}
              style={{ color: "steelblue", fontSize: 13 }}
            >
              {" "}
              Read More...{" "}
            </Link>
          </Typography>
        </CardContent>
      </Card>

      {/* Coordinator Card */}
      <Card
        sx={{
          height: 450,
          width: 300,
          textAlign: "center",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          borderRadius:2,
          backgroundColor: '#e9ecf2',
          "&:hover": {
            transform: "scale(1.01)",
            boxShadow: "0px 12px 30px rgba(0, 0, 0, 0.4)",
            border: '1.3px solid #A70606'
          },
        }}
        elevation={3}
      >
        <CardMedia
          component="img"
          height="280"
          image={coordinator}
          alt="Coordinator"
        />
        <CardContent>
          <Typography variant="h6" style={{fontSize:'15px', color: '#A70606'}} gutterBottom>
            COORDINATOR'S DESK
          </Typography>
          <h5 style={{marginBottom:'9px', fontSize:'21px', fontWeight:'500'}}>Prof. Dr. Nivedita G. Ekbote</h5>
          <Typography
            variant="body2"
            className="P-tag text-justify vertical-texts"
          >
            The foundation of MIBM is its highly qualified and motivated
            faculties with their expertise in various areas like Economics,
            Finance...
            <Link
              to={"/aboutUs/CoordinatorsDesk"}
              style={{ color: "steelblue", fontSize: 13 }}
            >
              {" "}
              Read More...{" "}
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
